export const textGradientStyles =
  "text-transparent bg-clip-text bg-gradient-to-r from-ai-start to-ai-end";
